import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal_container: {
        display: 'flex',
        minWidth: '500px',
        flexDirection: 'column',
        alignItems: 'flex-end',
        justifyContent: 'center',
        backgroundColor: theme.palette.common.white,
        borderRadius: '4px',
        padding: '16px',
        border: `1px solid ${theme.palette.grey[200]}`,
    },
    input: {
        marginTop: '16px'
    },
    btn_container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        width: '100%'
    },
    display_flex: {
        display: 'flex',
        gap: '8px',
        width: '100%'
    },
    alert:{
        width: '100%',
        marginTop: '10px'
    },
    hint:{
        width: '100%',
        padding: '8px 0',
        textAlign: 'left'
    },
    articles_container: {
        marginTop: '20px'
    }
}));

export {useStyles}